export default __webpack_public_path__ + "static/media/history_1960_00.fa30c030.png";